import React, { useState, useEffect, Fragment } from "react";
import ReactSelect from "react-select";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import Firebase from "../../../firebasehelper";
import { TerritoryOptions } from "../../../Constants/retailer";
import { perkTypes } from "../../../Constants/selections";
import DateTimePicker from "../../../components/DateTimePicker";
import FullImageUpload from "../../../components/ContentUpload/FullImageUpload";
import { IMAGE_UPLOAD } from "../../../Constants/types";
const AddPerkModal = ({ onCreate, territory }) => {
  const [retailers, setRetailers] = useState([]);
  const [retailer, setRetailer] = useState(null);
  const [type, setType] = useState("");
  const [title, setTitle] = useState("");
  const [logo, setMediaURL] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [banner, setBanner] = useState("");
  const [loading, setLoading] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  useEffect(() => {
    if (territory) loadRetailers();
  }, [territory]);
  const loadRetailers = () => {
    Firebase.getAllRetailers((retailers) => {
      const res = Object.values(retailers).filter(
        (obj) =>
          (obj.territory || TerritoryOptions[0]) === territory &&
          obj.ecopayRetailer
      );
      const filteredRes = res
        .sort((a, b) => a.retailerName.localeCompare(b.retailerName))
        .map((obj) => ({
          label: obj.retailerName,
          value: obj,
        }));
      setRetailers(filteredRes);
    });
  };
  const uploadContent = (type) => async (mediaContent) => {
    const uploadFolder = "advent_planner/";
    const title = new Date().getTime().toString();
    setLoading(true);
    let media_url = await Firebase.uploadImg(mediaContent, title, uploadFolder);
    setLoading(false);
    if (type === "thumbnail") setThumbnail(media_url);
    else if (type === "banner") setBanner(media_url);
    else if (type === "logo") setMediaURL(media_url);
  };

  /* handlers */
  const handleChangeTitle = ({ target }) => {
    setTitle(target.value);
  };
  const handleChangeStartTime = (time) => {
    setStartTime(time.valueOf());
  };
  const handleChangeEndTime = (time) => {
    setEndTime(time.valueOf());
  };
  const handleSelectRetailer = (retailer) => {
    setRetailer(retailer);
  };
  const handleSelectType = ({ value }) => {
    setType(value);
  };
  const handleOnCreate = () => {
    if (type === perkTypes[0]) {
      console.log("retailer.value", retailer.value);
      onCreate(retailer.value);
    } else {
      const content = {
        title,
        logo,
        thumbnail,
        banner,
        startTime,
        endTime,
      };
      onCreate(content);
    }
  };
  const limitedTimePerkForm = () => {
    return (
      <div
        style={{
          marginBottom: 10,
        }}
      >
        <p className="add-event-title">Offer Title</p>
        <input
          className="form-control form-control-md "
          name="perkName"
          placeholder="Input insider perk name here..."
          onChange={handleChangeTitle}
        />
        <p className="add-event-title mt-2">Offer Thumbnail</p>
        <FullImageUpload onChangeContent={uploadContent("thumbnail")} />
        <p className="add-event-title mt-2">Promotion Banner</p>
        <FullImageUpload onChangeContent={uploadContent("banner")} />
        <p className="add-event-title mt-2">Promotion Logo</p>
        <FullImageUpload onChangeContent={uploadContent("logo")} />
        <Fade
          in={loading}
          style={{
            transitionDelay: loading ? "800ms" : "0ms",
          }}
          unmountOnExit
        >
          <Fragment>
            <CircularProgress />
          </Fragment>
        </Fade>
        <p className="add-event-title mt-2">From</p>
        <DateTimePicker onTimeChange={handleChangeStartTime} />
        <p className="add-event-title mt-2">Until</p>
        <DateTimePicker onTimeChange={handleChangeEndTime} />
      </div>
    );
  };
  return (
    <div
      className="modal fade"
      id="add_daily_perk_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add a limited time perk offer</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <p className="add-event-title">Select type</p>
            <div className="form-group row">
              <div className="col-12">
                <ReactSelect
                  onChange={handleSelectType}
                  options={perkTypes.map((type) => ({
                    value: type,
                    label: type,
                  }))}
                  placeholder="Select type..."
                ></ReactSelect>
              </div>
            </div>
            {type === perkTypes[0] && (
              <Fragment>
                <p className="add-event-title">Select retailer</p>
                <div className="form-group row">
                  <div className="col-12">
                    <ReactSelect
                      isSearchable={true}
                      onChange={handleSelectRetailer}
                      options={retailers}
                      placeholder="Select retailer..."
                      noOptionsMessage={() => "..."}
                    ></ReactSelect>
                  </div>
                </div>
                {retailer && (
                  <center>
                    <img
                      src={retailer.value.logo}
                      height="100px"
                      alt="retailer"
                    />
                  </center>
                )}
              </Fragment>
            )}

            {type === perkTypes[1] && limitedTimePerkForm()}

            <div className="modal-footer">
              <button
                className="btn btn-green"
                onClick={handleOnCreate}
                data-dismiss="modal"
              >
                Create
              </button>
              <button className="btn btn-orange" data-dismiss="modal">
                Later
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPerkModal;



// WEBPACK FOOTER //
// ./src/screens/AdventPlanner/components/AddPerkModal.js